module.exports = __webpack_public_path__ + "static/media/gradientBackgroundBronzeCard.fe43986c.png";